
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"4","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.64 8H2.298V2.484c0-.421-.073-.737-.219-.945-.146-.208-.364-.312-.656-.312a1.03 1.03 0 00-.414.078c-.12.047-.242.125-.367.234l-.32-.453C.627.836.908.66 1.163.562a2.07 2.07 0 01.79-.156c.577 0 1.002.16 1.273.477.276.318.414.818.414 1.5V8z","fill":"currentColor"}})])
          )
        }
      }
    